

export const OrderSort = (arr)=>{
  return  arr.sort((a,b)=>{
   return   a.order - b.order
  })
}
export const OrderSortNode = (arr, reverse = false)=>{
  if(reverse){
    return  arr.sort((a,b)=>{
      return    b.node.order - a.node.order
    })
  }else {
    return  arr.sort((a,b)=>{
      return    a.node.order - b.node.order
    })
  }

}